import React, {useState, useCallback} from 'react';
import {useWindowClearer} from "components/sidebar/useWindowClearer.js";

export const useContextMenu = ({ref, useTop=true, useLeft=true}) => {
    let [dropdownPos, setDropdownPos] = useState(undefined);
    useWindowClearer({clear: () => setDropdownPos(undefined), selected: dropdownPos});

    const onContextMenu = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (ref) {
            let rect = ref.current.getBoundingClientRect();
            let drop ={
                x: useLeft ? e.clientX - rect.left + ref.current.scrollLeft: e.clientX,
                y: useTop ? e.clientY - rect.top + ref.current.scrollTop : e.clientY
            };
            setDropdownPos(drop);
        } else {
            let drop = {x: e.clientX, y: e.clientY};
            setDropdownPos(drop);
        }
    }, [setDropdownPos, useTop, useLeft, ref]);

    return {onContextMenu, dropdownPos, setDropdownPos};
};
